import React, { useEffect } from 'react';
import 'particles.js';

const ParticlesComponent = () => {
  useEffect(() => {
    // Configure as opções das partículas aqui
    const options = {
      particles: {
        number: {
          value: 40,
          density: {
            enable: true,
            value_area: 80
          }
        },
        color: {
          value: "#ffffff"
        },
        shape: {
          type: "circle",
          stroke: {
            width: 0,
            color: "#000000"
          },
          polygon: {
            nb_sides: 30
          },
          image: {
            src: "img/github.svg",
            width: 100,
            height: 100
          }
        },
        opacity: {
          value: 1,
          random: true,
          anim: {
            enable: true,
            speed: 1,
            opacity_min: 0.1,
            sync: false
          }
        },
        size: {
          value: 2,
          random: true,
          anim: {
            enable: false,
            speed: 80,
            size_min: 1,
            sync: false
          }
        },
        line_linked: {
          enable: true,
          distance: 60,
          color: "#ffffff",
          opacity: 0.8,
          width: 0.5
        },
        move: {
          enable: true,
          speed: 1.2,
          direction: "none",
          random: false,
          straight: false,
          out_mode: "out",
          bounce: true,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 1200
          }
        }
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: true,
            mode: "grab"
          },
          onclick: {
            enable: false,
            mode: "push"
          },
          resize: true
        },
        modes: {
          grab: {
            distance: 100,
            line_linked: {
              opacity: 1
            }
          },
          bubble: {
            distance: 100,
            size: 10,
            duration: 2,
            opacity: 8,
            speed: 3
          },
          repulse: {
            distance: 400,
            duration: 0.4
          },
          push: {
            particles_nb: 4
          },
          remove: {
            particles_nb: 2
          }
        }
      },
      retina_detect: true
    };

    // Inicializa as partículas usando a função global
    if (window.particlesJS) {
      window.particlesJS('particles-js', options);
    } else {
      console.error('particlesJS não está disponível.');
    }

    // Limpeza ao desmontar o componente
    return () => {
      const canvas = document.querySelector('#particles-js > canvas');
      if (canvas) {
        canvas.remove();
      }
    };
  }, []);

  return <div id="particles-js" style={{ width: '100%', height: '100vh' }}></div>;
};

export default ParticlesComponent;
